package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource

data class Chapter(
    val number: Int,
    val title: StringResource,
    val character: Characters = Characters.Alyn
)

